import { AxiosInstance } from 'axios';

import { IMessage } from '@sv-support-sdk/chat-shared-types/src/common/messages';
import { ExpandPromiseResponse } from '@sv-support-sdk/shared-types/src/common/utils';

const contentTypeForm = 'application/x-www-form-urlencoded';

interface MessageSendRequest {
  user_id: string;
  chat_id: number;
  hash?: string;
  user_type: string;
  message: string;
  uuid?: string;
};

interface MessageSendResponse {
  chatId: number;
  messages: IMessage[];
}

interface CheckLastMessageRequest {
  chat_id: number;
  hash: string;
  message_id: number;
}

interface ChatLastMessageResponse {
  latest: boolean;
  messages: IMessage[];
  status: number;
}

interface CallbackRequest {
  chat_id: number;
  hash: string;
  answer: number;
}

interface ReadMessageRequest {
  chat_id: number;
  message_id: number;
  hash: string;
}

export default (api: AxiosInstance) => ({
  sendMessage: <T>(data: MessageSendRequest): ExpandPromiseResponse<MessageSendResponse, T> =>
    api.post('new-message', data),
  sendAttachment: (data: FormData, onUploading: (progress: number) => void) =>
    api.post('new-attachment', data, {
      headers: {
        'content-type': contentTypeForm,
      },
      onUploadProgress: (progressEvent) => {
        const progress = Math.round(10 + (progressEvent.total ? (progressEvent.loaded / progressEvent.total) * 90 : 0));
        onUploading(progress);
      },
    }),
  checkLastMessage: <T>(params: CheckLastMessageRequest): ExpandPromiseResponse<ChatLastMessageResponse, T> =>
    api.get('verify-latest-message', { params }),
  updateCallback: (id: number, data: CallbackRequest) => api.put(`callback/${id}`, data),
  readMessages: (params: ReadMessageRequest) => api.get('read-messages', { params }),
});
